import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ReleaseStartDateChanged extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ReleaseStartDateChanged';

    public constructor(public releaseId: string, public date: string) {
        super(ReleaseStartDateChanged.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ReleaseStartDateChanged): void => {
    const release = state.releases.find((x) => x.id === action.releaseId);
    release.startDate = action.date;
};

//@ts-ignore
registerReducer(ReleaseStartDateChanged.ACTION_TYPE, reducer);
